import React, { FC, MouseEvent } from "react";

import { Button, Icon } from "../../common";
import { useTriggerToastOnRTKError } from "../../../hooks/useTriggerToastOnRTKError";
import { useCancelInvoiceMutation } from "../../../store/services/invoices";
import { toastSuccess } from "../../../utils/toasts";

type Props = {
  className?: string;
  invoiceId: string;
  label?: boolean;
};

export const CancelInvoiceAction: FC<Props> = ({
  className,
  invoiceId,
  label,
}) => {
  const [cancelInvoice, { isError, error }] = useCancelInvoiceMutation();
  useTriggerToastOnRTKError(isError, error);

  const cancelHandler = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    await cancelInvoice(invoiceId);
    toastSuccess("Invoice cancelled");
  };

  const variant = label ? Button.variant.TERTIARY : Button.variant.SECONDARY;

  return (
    <Button
      contentClassName={className}
      icon={!label}
      onClick={cancelHandler}
      variant={variant}
    >
      {label && <span className="text-orange-500">Cancel</span>}
      <Icon icon="Delete" size={24} className="text-orange-500" disableFill />
    </Button>
  );
};
